import {is_touch} from "../tools/helpers";

export const date_field = () => {

  const event_trigger = is_touch() ? 'touchstart' : 'focus';


  document.querySelectorAll('[name="birthdate"]').forEach(input => {
    input.setAttribute('type', 'text');

    input.addEventListener(event_trigger, event => {

      input.setAttribute('type', 'date');
      //input.showPicker();

    });
    input.addEventListener('blur', event => {
      if (input.value === '') {
        input.setAttribute('type', 'text');
      }
    });
  });
}


export const comment_field = () => {
  // Remove state field
  document.querySelectorAll(`[name^="item_meta"][name$="[state]"]`).forEach(input => {

  })


  document.querySelectorAll('.field__yes-no-comment').forEach(input => {
    input.addEventListener('change', event => {
      comment_visibility(input);
    });


    // Check if input is checked
    if (input.checked) {
      comment_visibility(input);
    }
  })

}


const comment_visibility = (input) => {

  const comment = input.closest('.frm_top_container').querySelector('.frm_comment');
  const field_container = comment.closest('.frm_form_field');
  let value_to_show = comment.classList.contains('reverse') ? 'Non' : 'Oui';

  if ( input.value === value_to_show) {
    comment.classList.remove('frm_pos_none')
    field_container.classList.add('frm_required_field')
    comment.classList.add('frm_required_field')
    comment.querySelector('textarea').setAttribute('aria-required', 'true');
  } else {

    comment.classList.add('frm_pos_none');
    field_container.classList.remove('frm_required_field')
    comment.classList.remove('frm_required_field');
    comment.querySelector('textarea').setAttribute('aria-required', 'false');
  }
}
